import { IconCode } from "../../../../../../contracts/iconCode";
import { IKeyValueItem } from "../../../../../../Global/Base/DataSources/Interfaces";
import { EnumUtils } from "../../../../../../Global/Base/Utils/EnumUtils";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { CaseInsensitiveMap } from "../../../../../UI.React/types/multiweb";
import { FilterGroup } from "../FilterGroup";
import { ValueListButton } from "./ValueListButton";

export class IconValueListButton extends ValueListButton {
    protected override initializeValueList(fgroup: FilterGroup): void {
        const dataType: CaseInsensitiveMap<string> = new CaseInsensitiveMap<string>([[fgroup.attrName, "Icon"]]);
        this._valueList.init(fgroup.parent.objectName, [fgroup.attrName], this.frameContext, fgroup.parent.frameCondition, fgroup.parent.frameConditionParams, fgroup.parent.disableValueShortening, dataType);
    }

    protected override renderElement(span: HTMLElement, selectedItem: IKeyValueItem): void {
        if (EnumUtils.hasEnumValue(IconCode, selectedItem.key.toString().trim())) {
            if (!selectedItem.value) {
                selectedItem.value = selectedItem.key;
            }
            span.classList.add("Icon", selectedItem.value.toString().trim());
        } else {
            span.textContent = selectedItem.value;
        }
    }
}

registerCustomElement("tsc-IconValueListButton", IconValueListButton);
